/* eslint-disable no-unused-vars */
const Autodesk = window.Autodesk;
import store from '@/store';
import { getAllParentsIds } from '@/utils/forgeUtils'
import { getAMISInspectionTagsByIds } from '@/utils/amisAPIs'

class CustomContextMenuExtension extends Autodesk.Viewing.Extension {
    constructor(viewer, options) {
        super(viewer, options);
        this.viewer = viewer;
        this.contextMenu = viewer.contextMenu;
        this.location = null;
    }

    load() {
        this.viewer.canvas.addEventListener("mousedown", this.handleMouseDown);

        return true;
    }

    unload() {
        this.viewer.canvas.removeEventListener("mousedown", this.handleMouseDown);
        return true;
    }

    handleMouseDown = (event) => {
        // To handle right click event only.
        if (event.which !== 3) return;
        
        let selection = this.viewer.getSelection();
        
        // To handle selected elements right click event only.
        if (!selection.length) {
            this.viewer.setContextMenu(this.contextMenu);
            return;
        }

        this.location = { clientX: event.clientX, clientY: event.clientY }
        let dbId = selection[0];
        let dbIds = [dbId, ...getAllParentsIds(this.viewer, dbId)];
        let { showEquipmentPopup, showInspectionPopup, showAnnotationPopup, showPipelinePopup, showStructuralPopup } = store.state.userSettings.displaySettings;
        let typesToLoad = {
            'Equipments': showEquipmentPopup,
            'Structural': showStructuralPopup,
            'Pipelines': showPipelinePopup,
            'Inspections': showInspectionPopup,
            'Annotations': showAnnotationPopup
        }
        this.getPopupData(dbIds, typesToLoad).then((tags) => {
            if (tags.length) {
                store.state.forgeService.showListOfThumbnails(tags, event, '3d');
                this.viewer.setContextMenu(null);
            } else {
                this.viewer.setContextMenu(this.contextMenu);
            }
            return;
        })   

        this.viewer.setContextMenu(null);
    }

    // {clientX: xxx, clientY: xxx}
    showForgeContextMenu = () => {
        store.commit('hideThumbnailPopup', '3d');
        this.viewer.setContextMenu(this.contextMenu);
        this.viewer.contextMenu.show(this.location)
    }

    // TODO: Refactor this function and call the API to get the 3dObjects with this DBIds then return the tags.
    getPopupData = (dbIds, typesToLoad) => {
        return new Promise((resolve, reject) => {
            let inspectionsPromise = typesToLoad['Inspections'] ? this.getInspectionsForDbIds(dbIds) : Promise.resolve([]);
            let equipmentsPromise = typesToLoad['Equipments'] ? this.getAutomaticTagsForDbIds(dbIds) : Promise.resolve([]);
            let structuralPromise = typesToLoad['Structural'] ? this.getStructuralTagsForDbIds(dbIds) : Promise.resolve([]);
            let pipelinesPromise = typesToLoad['Pipelines'] ? this.getPipelinesTagsForDbIds(dbIds) : Promise.resolve([]);
            let annotationsPromise = typesToLoad['Annotations'] ? this.getAnnotationsForDbIds(dbIds) : Promise.resolve([]);
    
            Promise.all([inspectionsPromise, equipmentsPromise, structuralPromise, pipelinesPromise, annotationsPromise])
                .then(([inspections, equipments, structural, pipelines, annotations]) => {
                    resolve([...equipments, ...structural, ...pipelines, ...inspections, ...annotations]);
                })
                .catch(reject);
        });
    };
    
    getPopupData2 = (dbIds, typesToLoad) => {
        return new Promise((resolve, reject) => {
            let pending = Object.values(typesToLoad).filter(t => t).length;

            let inspections = [];
            let annotations = [];
            let equipments = [];
            let structural = [];
            let pipelines = [];

            if (pending == 0) resolve([]); 

            if (typesToLoad['Inspections']) {
                this.getInspectionsForDbIds(dbIds)
                    .then(tags => {
                        inspections = tags ?? [];
                    })
                    .finally(_ => {
                        pending--;

                        if (pending === 0) resolve([...equipments, ...structural, ...pipelines, ...inspections, ...annotations]);
                    });
            }

            if (typesToLoad['Equipments']) {
                this.getAutomaticTagsForDbIds(dbIds)
                    .then(tags => {
                        equipments = tags ?? [];
                    }).finally(_ => {
                        pending--;

                        if (pending === 0) resolve([...equipments, ...structural, ...pipelines, ...inspections, ...annotations]);
                    });
            }

            if (typesToLoad['Structural']) {
                this.getStructuralTagsForDbIds(dbIds)
                    .then(tags => {
                        structural = tags ?? [];
                    }).finally(_ => {
                        pending--;

                        if (pending === 0) resolve([...equipments, ...structural, ...pipelines, ...inspections, ...annotations]);
                    });
            }

            if (typesToLoad['Pipelines']) {
                this.getPipelinesTagsForDbIds(dbIds)
                    .then(tags => {
                        structural = tags ?? [];
                    }).finally(_ => {
                        pending--;

                        if (pending === 0) resolve([...equipments, ...structural, ...pipelines, ...inspections, ...annotations]);
                    });
            }

            if (typesToLoad['Annotations']) {
                this.getAnnotationsForDbIds(dbIds)
                    .then(tags => {
                        annotations = tags ?? [];
                    }).finally(_ => {
                        pending--;

                        if (pending === 0) resolve([...equipments, ...structural, ...pipelines, ...inspections, ...annotations]);
                    });
            }

        })
    }
    getInspectionsForDbIds = (dbIds) => {
        return new Promise((resolve, reject) => {
            if (store.state.forgeSettings?.isAMIS) {
                
                const set = store.getters.GET_ALL_AMIS_TAGS_IDS;

                const ids = set.filter(t => dbIds.some(dbId => t.children.some(c => c.dbId == dbId))).map(t => t.id) ?? [];

                if (!ids.length) resolve([]);

                getAMISInspectionTagsByIds(ids).then(tags => resolve(tags)).catch(error => reject(error))
                
            } else {
                let inspections = store.state.inspections.filter(i => i.children && i.children.length && i.children.some(c => dbIds.includes(c.dbId)));
                resolve(inspections);
            }
        })
    }
    getAutomaticTagsForDbIds = (dbIds) => {
        return new Promise((resolve, reject) => {
            let tags = store.state.tags.filter(i => i.children && i.children.length && i.children.some(c => dbIds.includes(c.dbId)));
            
            if (tags.length) return resolve(tags);

            let ids = store.state.TAGS.allExistingAutomaticDbids.filter(t => dbIds.includes(t.dbid)).map(t => t.id);

            if (!ids.length) return resolve([]);
            
            store.state.forgeService.getAutomaticTagsByIds(ids).then(tags => resolve(tags)).catch(error => reject(error))
        })
    }
    getStructuralTagsForDbIds = (dbIds) => {
        let ids = store.getters.GET_ALL_EXISTING_STRUCTURAL_TAGS.filter(t => dbIds.includes(t.dbid)).map(t => t.id);

        let manualStructural = store.getters.GET_MANUAL_STRUCTURAL_TAGS.filter(t => t.children.some(c => dbIds.includes(c.dbId))).map(t => t.id) ?? [];

        ids = [...ids, ...manualStructural];

        if (!ids.length) return Promise.resolve([]);

        return store.dispatch('GET_STRUCTURAL_TAGS_BY_IDS', { ids });
    }
    getPipelinesTagsForDbIds = (dbIds) => {
        let ids = store.getters.GET_ALL_EXISTING_PIPELINES_TAGS.filter(t => dbIds.includes(t.dbid)).map(t => t.id);

        let manualPipelines = store.getters.GET_MANUAL_PIPELINES_TAGS.filter(t => t.children.some(c => dbIds.includes(c.dbId))).map(t => t.id) ?? [];

        ids = [...ids, ...manualPipelines];

        if (!ids.length) return Promise.resolve([]);

        return store.dispatch('GET_PIPELINES_TAGS_BY_IDS', { ids });
    }
    getAnnotationsForDbIds = (dbIds) => {
        return new Promise((resolve, reject) => {
            try {
                let annotations = store.state.annotations.filter(annotation => annotation.children && annotation.children.length && annotation.children.some(c => dbIds.includes(c.dbId)));
                resolve(annotations);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        })
    }
}

Autodesk.Viewing.theExtensionManager.registerExtension('CustomContextMenuExtension', CustomContextMenuExtension);